import React, { useEffect, useReducer } from "react";
import { Alert, Card, Col, Row, Table, Badge, Image } from "react-bootstrap";
import ModuleRecordsPerPageDropdown from "../../../../UI/modules/views/partials/common/ModuleRecordsPerPageDropdown";
import ModuleSearchBox from "../../../../UI/modules/views/partials/common/ModuleSearchBox";
import ModuleStatusDropdown from "../../../../UI/modules/views/partials/common/ModuleStatusDropdown";
import ModuleDynamicFilterDropdown from "../../../../UI/modules/views/partials/common/ModuleDynamicFilterDropdown";
import ModuleDynamicMultiFilterDropdown from "../../../../UI/modules/views/partials/common/ModuleDynamicMultiFilterDropdown";
import { listingInitialState, listingReducer } from "../../../../../reducers/module/listingReducer";
import { getLookupOptionsByName } from "../../../../../helpers/CommonHelper";
import axios from "../../../../../config/axios";

const SearchArea = ({
  moduleConfig,
  setFilter,
  appliedFilters,
  resetFilters,
}) => {
    const [listingState, listingDispatch] = useReducer(
    listingReducer,
    listingInitialState
  );

  const loadItems = async () => {
    listingDispatch({ type: "FETCH_REQUEST" });

    try {
      // First API call
      const res = await axios.get(`/lookups`);

      listingDispatch({
        type: "FETCH_SUCCESS",
        payload: res?.data,
      });
    } catch (error) {
      listingDispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });
    }
  };

  useEffect(() => {
    loadItems();
  }, []);
  return (
    <>
      {(appliedFilters.limit ||
        appliedFilters.q ||
        appliedFilters.foodTime ||
        appliedFilters.hotOrCold ||
        appliedFilters.vegOrNonVeg ||
        appliedFilters["allergens[]"] ||
        appliedFilters.status) && (
        <div div className=" text-right">
          <span className="resetFilters" onClick={() => resetFilters()}>
            <i className="fas fa-times" /> Reset Filters
          </span>
        </div>
      )}

      <div className="position-relative">
        <Card className="listingPageHeader p-0 m-0 p-1 mt-1 mb-1">
          <Card.Body className=" p-0 m-0">
            <Row className="mb-0">
              {moduleConfig.hasPagination === true &&
                moduleConfig.perPageItemsOptions &&
                moduleConfig.perPageItemsOptions.length > 0 && (
                  <Col className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 pt-0">
                    <ModuleRecordsPerPageDropdown
                      selectedPerPageItems={moduleConfig.perPageItems}
                      perPageItemsOptions={moduleConfig.perPageItemsOptions}
                      setFilter={setFilter}
                    />
                  </Col>
                )}

              {moduleConfig.hasStatusSearch === true && (
                <Col className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 pt-1">
                  <ModuleStatusDropdown
                    setFilter={setFilter}
                    appliedFilters={appliedFilters}
                    statusOptions={[
                      {
                        label: "Select Status...",
                        value: "all",
                      },
                      {
                        label: "Enabled",
                        value: "1",
                      },
                      {
                        label: "Disabled",
                        value: "0",
                      },
                    ]}
                  />
                </Col>
              )}
              <Col className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 pt-1">
                <ModuleDynamicFilterDropdown
                  filterField={"foodTime"}
                  setFilter={setFilter}
                  appliedFilters={appliedFilters}
                  options={[
                    {
                      label: "Select foodTime...",
                      value: "all",
                    },
                    {
                      label: "Breakfast",
                      value: "Breakfast",
                    },
                    {
                      label: "Lunch",
                      value: "Lunch",
                    },
                    {
                      label: "Afternoon Snack",
                      value: "Afternoon Snack",
                    },
                    {
                      label: "Dinner",
                      value: "Dinner",
                    },
                  ]}
                />
              </Col>
              <Col className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 pt-1">
                <ModuleDynamicFilterDropdown
                  filterField={"hotOrCold"}
                  setFilter={setFilter}
                  appliedFilters={appliedFilters}
                  options={[
                    {
                      label: "Select hot or cold...",
                      value: "all",
                    },
                    {
                      label: "Hot",
                      value: "Hot",
                    },
                    {
                      label: "Cold",
                      value: "Cold",
                    },
                  ]}
                />
              </Col>
              <Col className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 mt-1">
                <ModuleDynamicFilterDropdown
                  filterField={"vegOrNonVeg"}
                  setFilter={setFilter}
                  appliedFilters={appliedFilters}
                  options={[
                    {
                      label: "Select veg or non veg...",
                      value: "all",
                    },
                    {
                      label: "Veg",
                      value: "Veg",
                    },
                    {
                      label: "Non Veg",
                      value: "Non Veg",
                    },
                  ]}
                />
              </Col>
              {moduleConfig.hasSearch === true && (
                <Col className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 mt-1">
                  <ModuleSearchBox
                    setFilter={setFilter}
                    appliedFilters={appliedFilters}
                  />
                </Col>
              )}

              <Col className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 mt-1">
                <ModuleDynamicMultiFilterDropdown
                  filterField="allergens"
                  title="Select Allergens"
                  appliedFilters={appliedFilters}
                  setFilter={setFilter}
                  options={getLookupOptionsByName(listingState?.data?.lookups, "Allergens")}
                />

              </Col>
            </Row>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default SearchArea;
